(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.EmailIconSvg = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var EmailIcon = function EmailIcon() {
    return _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        xlink: "http://www.w3.org/1999/xlink",
        width: "56",
        height: "56",
        viewBox: "0 0 56 56"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("circle", { id: "a", cx: "28", cy: "28", r: "28" })
      ),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "mask",
          { id: "b", fill: "#fff" },
          _react2.default.createElement("use", { href: "#a" })
        ),
        _react2.default.createElement("use", { fill: "#DFE1E7", href: "#a" }),
        _react2.default.createElement(
          "g",
          { mask: "url(#b)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(11 10)" },
            _react2.default.createElement("path", {
              fill: "#2D344B",
              d: "M.894 9.934L17.006.307a1 1 0 0 1 1.025 0l16.112 9.627a1 1 0 0 1 .487.858v20.61a1 1 0 0 1-1 1H1.407a1 1 0 0 1-1-1v-20.61a1 1 0 0 1 .487-.858z"
            }),
            _react2.default.createElement("rect", { width: "29", height: "20", x: "3", y: "6", fill: "#FFF", rx: "1" }),
            _react2.default.createElement("path", {
              fill: "#757D99",
              d: "M2.18 12.758L11 23.484h13l8.858-10.735a1 1 0 0 1 1.772.636v18.017a1 1 0 0 1-1 1H1.407a1 1 0 0 1-1-1v-18.01a1 1 0 0 1 1.773-.634z"
            }),
            _react2.default.createElement("rect", {
              width: "16.171",
              height: "1.037",
              x: "9",
              y: "14",
              fill: "#2D344B",
              rx: ".519"
            }),
            _react2.default.createElement("rect", {
              width: "8.759",
              height: "1.037",
              x: "9",
              y: "17",
              fill: "#2D344B",
              rx: ".519"
            }),
            _react2.default.createElement("rect", {
              width: "11.05",
              height: "1.037",
              x: "9",
              y: "11",
              fill: "#2D344B",
              rx: ".519"
            })
          )
        )
      )
    );
  };

  exports.default = EmailIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/icons/EmailIcon.svg.js
// module id = 2018
// module chunks = 1